import axiosInstance from '@/utils/api.js'

var state = {
  traffic: []
}

var getters = {
  TRAFFIC: (state) => {
    return state.traffic
  }
}

var mutations = {
  SET_TRAFFIC: (state, payload) => {
    state.traffic = payload
  }
}

var actions = {
  GET_TRAFFIC: async (context, payload) => {
    let result = await axiosInstance.get('/reports/traffic?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&account_id=0&accounting_period_id=0&type=' + payload.type)
    if (result.status === 200) {
      context.commit('SET_TRAFFIC', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/traffic.js